import './menu.css'

const Menu = () => {
    return (
      <div className="customBackground">
      <div className="center">
          <h2> MENU</h2>
          <div>
          <img src='https://images.unsplash.com/photo-1568031813264-d394c5d474b9?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=1169&q=80'
            alt="menu"></img>
          </div>
          <div>
            
          </div>
      </div>
      </div>
    )
  
  }
  
  export default Menu;